import { Chip, Stack } from "@mui/material";
import { ComponentColors } from "./types";

interface ShortcutsPreviewProps {
  selectedPalette: ComponentColors["shortcuts"];
}

const ShortcutsPreview = ({ selectedPalette }: ShortcutsPreviewProps) => {
  if (!selectedPalette) return null;

  return (
    <Stack
      direction="row"
      bgcolor={selectedPalette.container}
      p={1}
      alignItems="center"
      justifyContent="start"
      gap={1}
    >
      {[1, 2].map((item) => (
        <Chip
          key={item}
          label={`Pill ${item}`}
          sx={{
            backgroundColor: selectedPalette.background,
            color: selectedPalette.foreground,
            border: selectedPalette.outline
              ? `1px solid ${selectedPalette.outline}`
              : "none",
            "& .MuiChip-label": {
              color: selectedPalette.foreground,
            },
          }}
        />
      ))}
    </Stack>
  );
};

export default ShortcutsPreview;
